<template>
  <div class="img-btn-wrapper">
    <div class="fl-canvas fl-canvas--top" uses-configuration="A">
      <configuration-canvas
        emphasized-view="equal"
        :hotspots="false"
        :alwaysShowFullSpeaker="true"
        labels-position="bottom"
        suffix="main"
        key="mainCanvas"
        :configToLoad="configA"
      />
    </div>
    <div class="fl-canvas fl-canvas--bottom" uses-configuration="B">
      <configuration-canvas
        emphasized-view="equal"
        :hotspots="false"
        :alwaysShowFullSpeaker="true"
        labels-position="bottom"
        key="transitionCanvas"
        suffix="transition"
        :configToLoad="configB"
      />
    </div>
    <CircleButton :key="$route.params.id" :showButton="showButton" :onClick="nextRandomConfig"/>
  </div>
</template>


<script>
import CircleButton from "../CircleButton.vue";
import ConfigurationCanvas from "@/components/ConfigurationCanvas.vue";

export default {
  name: "feeling-lucky-content",
  props: {
    imageSrc: String,
    onClick: Function,
    showButton: Boolean
  },
  data() {
    return {
      configA: {},
      configB: {},
      currentTop: null,
      currentBottom: null
    };
  },
  created() {
    // get the configuration based on the route param
    if (!this.$route.params.id) {
      this.configuration = {};
      this.configuration.Text = "Hit Me";
    } else {
      this.configuration = this.getFeelingLuckyConfig(this.$route.params.id);
    }
    if (this.configuration.Fabric) {
      this.$store.commit("selectOption", {
        CategoryName: "Fabric",
        Id: this.configuration.Fabric
      });
      this.$store.commit("selectOption", {
        CategoryName: "Caps",
        Id: this.configuration.Caps
      });
      this.$store.commit("selectOption", {
        CategoryName: "Spine",
        Id: this.configuration.Spine
      });
      this.$store.commit("selectOption", {
        CategoryName: "Icon",
        Id: this.configuration.Icon
      });
      this.$store.commit("selectOption", {
        CategoryName: "Loop",
        Id: this.configuration.Loop
      });
    } else {
      this.$store.commit("selectOption", {
        CategoryName: "Fabric",
        Id: null
      });
      this.$store.commit("selectOption", {
        CategoryName: "Caps",
        Id: null
      });
      this.$store.commit("selectOption", {
        CategoryName: "Spine",
        Id: null
      });
      this.$store.commit("selectOption", {
        CategoryName: "Icon",
        Id: null
      });
      this.$store.commit("selectOption", {
        CategoryName: "Loop",
        Id: null
      });
    }
  },
  mounted() {
    this.currentTop = document.querySelector(".fl-canvas--top");
    this.currentBottom = document.querySelector(".fl-canvas--bottom");
    this.configA = this.currentConfig || {};
    this.configB = this.getNextConfig();
  },
  updated() {
    const wrapper = document.querySelector(".img-btn-wrapper");
    if (wrapper) {
      wrapper.classList.remove("img-btn-wrapper--animating");
    }

    if (!this.$route.params.id) {
      this.configuration = {};
      this.configuration.Text = "Hit Me";
    } else {
      this.configuration = this.getFeelingLuckyConfig(this.$route.params.id);
    }
    if (this.configuration.Fabric) {
      this.$store.commit("selectOption", {
        CategoryName: "Fabric",
        Id: this.configuration.Fabric
      });
      this.$store.commit("selectOption", {
        CategoryName: "Caps",
        Id: this.configuration.Caps
      });
      this.$store.commit("selectOption", {
        CategoryName: "Spine",
        Id: this.configuration.Spine
      });
      this.$store.commit("selectOption", {
        CategoryName: "Icon",
        Id: this.configuration.Icon
      });
      this.$store.commit("selectOption", {
        CategoryName: "Loop",
        Id: this.configuration.Loop
      });
    } else {
      if (
        this.$route.name === "feeling-lucky" ||
        this.$route.name === "SpeakerText"
      ) {
        // only remove everything if we're on a feeling lucky
        this.$store.commit("selectOption", {
          CategoryName: "Fabric",
          Id: null
        });
        this.$store.commit("selectOption", {
          CategoryName: "Caps",
          Id: null
        });
        this.$store.commit("selectOption", {
          CategoryName: "Spine",
          Id: null
        });
        this.$store.commit("selectOption", {
          CategoryName: "Icon",
          Id: null
        });
        this.$store.commit("selectOption", {
          CategoryName: "Loop",
          Id: null
        });
      }
    }
  },
  watch: {
    "$route.params.id"(to, from) {
      const currentIndex = this.computedFeelingLuckyOptions.findIndex(
        fl => fl.Id === parseInt(from)
      );
      const nextIndex = this.computedFeelingLuckyOptions.findIndex(
        fl => fl.Id === parseInt(to)
      );
      if (nextIndex < currentIndex) {
        // if going backward
        let currentTop = document.querySelector(".fl-canvas--top");
        let currentBottom = document.querySelector(".fl-canvas--bottom");

        this.currentTop = currentTop;
        this.currentBottom = currentBottom;

        currentTop.classList.remove("fl-canvas--top");
        currentTop.classList.add("fl-canvas--bottom");
        currentBottom.classList.remove("fl-canvas--bottom");
        currentBottom.classList.add("fl-canvas--top");

        if (currentBottom.getAttribute("uses-configuration") === "A") {
          this.configA = this.currentConfig;
        } else {
          this.configB = this.currentConfig;
        }
      } else {
        // going forward
        if (this.currentTop.getAttribute("uses-configuration") === "A") {
          this.configA = this.nextConfig;
        } else {
          this.configB = this.nextConfig;
        }
      }
    }
  },
  computed: {
    nextConfig() {
      return this.getNextConfig() || null;
    },
    previousConfig() {
      return this.getPreviousConfig() || null;
    },
    currentConfig() {
      if (this.$route.name === "feeling-lucky" && !this.$route.params.id) {
        return this.$store.state.feelingLuckyIntro;
      }
      return this.getFeelingLuckyConfig(this.$route.params.id);
    },
    nextFeelingLuckyOption() {
      let routeId = this.$route.params.id;
      const randomFeelingLucky = this.$store.state.feelingLuckyRandomized;
      if (routeId) {
        const currentIndex = randomFeelingLucky.findIndex(
          fl => fl.Id === parseInt(routeId)
        );
        if (currentIndex !== randomFeelingLucky.length - 1) {
          return randomFeelingLucky[currentIndex + 1];
        } else {
          return {};
        }
      } else {
        return randomFeelingLucky[0];
      }
    },
    computedFeelingLuckyOptions() {
      return this.$store.state.feelingLuckyRandomized;
    }
  },
  methods: {
    getFeelingLuckyConfig(id) {
      if (id) {
        return this.$store.state.feelingLucky.find(
          fl => fl.Id === parseInt(id)
        );
      }
    },
    getNextConfig() {
      let routeId = this.$route.params.id;
      const randomFeelingLucky = this.$store.state.feelingLuckyRandomized;
      if (routeId) {
        const currentIndex = randomFeelingLucky.findIndex(
          fl => fl.Id === parseInt(routeId)
        );
        if (currentIndex !== randomFeelingLucky.length - 1) {
          return randomFeelingLucky[currentIndex + 1];
        } else {
          return {};
        }
      } else {
        return randomFeelingLucky[0];
      }
    },
    getPreviousConfig() {
      let routeId = this.$route.params.id;
      const randomFeelingLucky = this.$store.state.feelingLuckyRandomized;
      if (routeId) {
        const currentIndex = randomFeelingLucky.findIndex(
          fl => fl.Id === parseInt(routeId)
        );
        if (currentIndex !== 0) {
          return randomFeelingLucky[currentIndex - 1];
        } else {
          return this.$store.state.feelingLuckyIntro;
        }
      } else {
        return {};
      }
    },
    nextRandomConfig(event) {
      if (
        parseInt(this.$route.params.id) <
          this.computedFeelingLuckyOptions.length ||
        !this.$route.params.id
      ) {
        const wrapper = document.querySelector(".img-btn-wrapper");
        wrapper.classList.add("img-btn-wrapper--animating");
        document
          .querySelector(".fl-canvas--top")
          .addEventListener("animationend", this.animationEnded);
      }
    },
    animationEnded() {
      const wrapper = document.querySelector(".img-btn-wrapper");
      let currentTop = document.querySelector(".fl-canvas--top");
      let currentBottom = document.querySelector(".fl-canvas--bottom");

      this.currentTop = currentTop;
      this.currentBottom = currentBottom;

      currentTop.classList.remove("fl-canvas--top");
      currentTop.classList.add("fl-canvas--bottom");
      currentBottom.classList.remove("fl-canvas--bottom");
      currentBottom.classList.add("fl-canvas--top");
      wrapper.classList.remove("img-btn-wrapper--animating");

      this.goToNextPage();
    },
    goToNextPage() {
      const wrapper = document.querySelector(".img-btn-wrapper");
      document
        .querySelector(".fl-canvas--top")
        .removeEventListener("animationend", this.goToNextPage);
      const currentIndex = this.computedFeelingLuckyOptions.findIndex(
        fl => fl.Id === parseInt(this.$route.params.id)
      );
      var urlId = this.computedFeelingLuckyOptions[currentIndex + 1].Id;
      // wrapper.classList.remove("img-btn-wrapper--animating");
      this.$router.push({ name: "SpeakerChoices", params: { id: urlId } });
    }
  },
  components: { CircleButton, ConfigurationCanvas }
};
</script>

<style lang="scss" scopped>
// .img-btn-wrapper {
//   width: 100%;
//   margin-left: auto;
//   margin-right: auto;
//   position: relative;
//   @media (min-width: 992px) {
//     margin-left: auto;
//     margin-right: 0;
//   }
// }

// .crossfade-enter,
// .crossfade-leave-to {
//   opacity: 0;
// }
// .crossfade-enter-active,
// .crossfade-leave-active {
//   transition: opacity 3s ease-out;
// }

.fl-canvas {
  align-items: center;
  width: 100%;
  display: flex;
  position: absolute;
  top: calc(50% - 1em);
  transform: translateY(-50%);
  @media (min-width: 992px) {
      align-items: flex-start;
    height: 100%;
    top: 50%;
  }

  &--top {
    z-index: 1;
    .img-btn-wrapper--animating & {
      animation: fade 0.5s cubic-bezier(0.75, 0.08, 0.52, 1) 1 alternate;
      @supports (
        clip-path:
          polygon(
            0 0,
            47.4% 0,
            47.4% 50%,
            47.4% 50%,
            47.4% 0,
            100% 0,
            100% 100%,
            47.4% 100%,
            47.4% 50%,
            47.4% 50%,
            47.4% 100%,
            0 100%
          )
      ) {
        animation: swipe 0.5s cubic-bezier(0.75, 0.08, 0.52, 1);
        // animation: swipeSimple 20s cubic-bezier(0.75, 0.08, 0.52, 1);
      }
      .canvas-container-wrap--labels-bottom {
        &:before {
          opacity: 0;
        }
      }
    }
  }
  &--bottom {
    z-index: 0;
    opacity: 0;
    .img-btn-wrapper--animating & {
      opacity: 1;
    }
  }
}

@keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes swipe {
  0% {
    clip-path: polygon(
      0% -20%,
      47.4% 0%,
      47.4% 50%,
      47.4% 50%,
      47.4% 0%,
      100% 0%,
      100% 100%,
      47.4% 120%,
      47.4% 50%,
      47.4% 50%,
      47.4% 100%,
      0% 100%
    );
  }
  100% {
    clip-path: polygon(
      0% 100%,
      47.4% 100%,
      47.4% 50%,
      47.4% 50%,
      47.4% 0%,
      100% 0%,
      100% 0%,
      47.4% 0%,
      47.4% 50%,
      47.4% 50%,
      47.4% 100%,
      0% 100%
    );
  }
}

@keyframes swipeSimple {
  0% {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
  100% {
    clip-path: polygon(0% 100%, 100% 0%, 100% 0%, 0% 100%);
  }
}
</style>
